// @ts-nocheck

import { CommonActionTypes } from '../types/actions/common';
import { SearchActionTypes } from '../types/actions/search';

export const searchInitialState = {
  isLoading: false,
  query: '',
  matchIds: [],
  suggestion: '',
  categories: [],
  tournaments: [],
  bets: [],
  outcomes: [],
};

export default (state = searchInitialState, action) => {
  switch (action.type) {
    case CommonActionTypes.RECEIVE_ENTITIES: {
      if ('searchResults' in action.payload) {
        const {
          matchIds = [],
          categories = [],
          tournaments = [],
          bets = [],
          outcomes = [],
          suggestion,
        } = action.payload.searchResults;
        return {
          ...state,
          isLoading: false,
          matchIds,
          categories,
          tournaments,
          bets,
          outcomes,
          suggestion,
        };
      }
      return state;
    }

    case SearchActionTypes.SET_SEARCH_QUERY: {
      return {
        ...state,
        query: action.payload.query,
        isLoading: true,
      };
    }

    case SearchActionTypes.CLEAR_SEARCH: {
      return searchInitialState;
    }

    default:
      return state;
  }
};
